/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import Accordion from 'components/Accordion'
import Modal from 'components/Modal'
import RemoveCriterionCModal from './removeCriterionC'
import { SITE_STATUS_DRAFT_ID, SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_NOMINATED_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { requestCreateCriterionC, deleteCriterionC, requestGetCriterionCs, requestUpdateCriterionC } from 'api/criterionC'
import { AssessmentPageSubTittle, AssessmentPageSubTittleIconWrapper, AssessmentPageSubTittleWrapper, AssessmentPageTittle, AssessmentPageTittleWrapper } from '../../style'
import AccordionContent from './accordionContent'
import AccordionHeader from './accordionHeader'
import { EcosystemListTitle, EcosystemListTitleWrapper } from '../EcosystemData/style'

const defaultCriterionC = {
    ecoregion_id: null,
    ecoregion_c_sites_count: '',
    year: '',
    evidence_low_human_impact: '',
    evidence_intact_ecology: '',
    trigger_reason_id: [],
    trigger_reason_text: '',
    reassessment_flag: false,
    EcoRegion: {
        id: null,
        name: '',
    }
}

const tooltipXOffset = 0
const tooltipYOffset = 16
const criterionCList = ({ site }) => {
    const params = useParams()
    const [criterionCs, setCriterionCs] = useState([])
    const [isRemoveCriterionCModalOpen, setIsRemoveCriterionCModalOpen] = useState(false)
    const [willBeDeletedCriterionC, setWillBeDeletedCriterionC] = useState({})

    const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID

    async function createCriterionC() {
        const data = await requestCreateCriterionC(site.id, params.siteHistoryId)
        setCriterionCs((s) => {
            return [...s, data]
        })
    }

    async function getCriterionCs() {
        const data = await requestGetCriterionCs(site.id, editOnlySiteStatus ? site.sitehistoryId : params.siteHistoryId)
        setCriterionCs(data.sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at)).map((criterionC) => {
            return {
                ...criterionC,
                trigger_reason_id: criterionC.trigger_reason_id.length == 0 ? [1] : criterionC.trigger_reason_id,
            }
        })) 
    }

    async function requestDeleteCriterionC(criterionId) {
        await deleteCriterionC(criterionId, params.siteHistoryId)
        await getCriterionCs()
    }

    const openRemoveCriterionCModal = (criterion) => {
        setIsRemoveCriterionCModalOpen(true)
        setWillBeDeletedCriterionC(criterion)
    }

    const updateCriterionC = async (data) => {
        const criterionCId = data.criterionCId;
        delete data.criterionCId; // remove criterionCId from data object, as it is not needed in requestUpdateCriterionC
        const dataCrit = criterionCs.find((item) => item.site_ecointegrity_history_id === criterionCId || item.site_ecointegrity_id === criterionCId);
        let critCs;

        if (dataCrit?.trigger_reason_id == undefined || dataCrit?.trigger_reason_id.length == 0) {
            critCs = await requestUpdateCriterionC(criterionCId, params.siteHistoryId, { ...data, trigger_reason_id: [1] });
        }

        if (dataCrit?.trigger_reason_id.length > 0) {
            critCs = await requestUpdateCriterionC(criterionCId, params.siteHistoryId, data);
        }

        if (!Array.isArray(critCs)) return;
        setCriterionCs(critCs?.sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at)).map((criterionC) => {
            return {
                ...criterionC,
                trigger_reason_id: criterionC.trigger_reason_id.length == 0 ? [1] : criterionC.trigger_reason_id,
            }
        }))
    };

    useEffect(() => {
        const fetchCriterionCs = async () => {
            await getCriterionCs()
        }
        fetchCriterionCs()
    }, [])

    if (criterionCs.length === 0 && site.SiteStatusId !== SITE_STATUS_DRAFT_ID) {
        return null
    }

    const approvedCriterionCs = criterionCs.filter((item) => item?.is_approved_by_secretariat)
    const rejectedCriterionCs = criterionCs.filter((item) => !item?.is_approved_by_secretariat)

    const newCriterionCs = criterionCs.filter((item) => !item?.last_reassessment_date)
    const oldCriterionCs = criterionCs.filter((item) => item?.last_reassessment_date)

    return (
        <div>
            <Container>
                <Row>
                    <Col md={8} mdOffset={2}>
                        <AssessmentPageTittleWrapper>
                            <AssessmentPageTittle data-testid='legend-criterionC'>
                                <FormattedMessage id='criterionC' />
                            </AssessmentPageTittle>
                            <AssessmentPageSubTittleWrapper marginBottom='64px' data-testid='sub-legend-criterionC'>
                                <AssessmentPageSubTittle>
                                    <FormattedMessage id='criterionCSubTittle' />
                                </AssessmentPageSubTittle>
                                <Tooltip
                                    style={{ zIndex: 1000 }}
                                    placement='bottom'
                                    trigger={['hover']}
                                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                                    overlay={{ label: 'ecoRegion', infoTooltip: 'ecoRegionHint' }}
                                    hyper={'https://www.keybiodiversityareas.org/working-with-kbas/programme/regional-focal-points'}
                                    shortLink={'www.keybiodiversityareas.org'}
                                    type='big'
                                >
                                    <AssessmentPageSubTittleIconWrapper>
                                        <InfoIcon />
                                    </AssessmentPageSubTittleIconWrapper>
                                </Tooltip>
                            </AssessmentPageSubTittleWrapper>
                        </AssessmentPageTittleWrapper>
                    </Col>
                </Row>
                <Row>
                    <Col md={8} mdOffset={2} dataTest='criterionC-group'>
                        {criterionCs.length === 0 ? (
                            <AccordionContent item={defaultCriterionC} updateCriterionC={updateCriterionC} siteId={site.id} defaultPage={true} site={site} />
                        ) : (
                            <>
                                {site.SiteStatusId !== SITE_STATUS_NOMINATED_ID ? (
                                    <>
                                        {oldCriterionCs.length > 0 && (
                                            <>
                                                <Row>
                                                    <Col md={8} mdOffset={2}>
                                                        <EcosystemListTitleWrapper>
                                                            <EcosystemListTitle>
                                                                <FormattedMessage id='existingTriggers' />
                                                            </EcosystemListTitle>
                                                        </EcosystemListTitleWrapper>
                                                    </Col>
                                                </Row>
                                                <Accordion
                                                    items={oldCriterionCs}
                                                    contentProps={{ updateCriterionC, site }}
                                                    headerProps={{ openRemoveCriterionCModal, getCriterionCs, oldTriggers: true, site }}
                                                    contentComponent={AccordionContent}
                                                    headerComponent={AccordionHeader}
                                                    initialActive={null}
                                                />
                                            </>
                                        )}
                                        {newCriterionCs.length > 0 && (
                                            <>
                                                <Row>
                                                    <Col md={8} mdOffset={2}>
                                                        <EcosystemListTitleWrapper addMarginTop={true}>
                                                            <EcosystemListTitle>
                                                                <FormattedMessage id='newTriggers' />
                                                            </EcosystemListTitle>
                                                        </EcosystemListTitleWrapper>
                                                    </Col>
                                                </Row>
                                                <Accordion
                                                    items={newCriterionCs}
                                                    contentProps={{ updateCriterionC, site }}
                                                    headerProps={{ openRemoveCriterionCModal, getCriterionCs, newTriggers: true, site }}
                                                    contentComponent={AccordionContent}
                                                    headerComponent={AccordionHeader}
                                                />
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {approvedCriterionCs.length > 0 && (
                                            <>
                                                <Row>
                                                    <Col md={8} mdOffset={2}>
                                                        <EcosystemListTitleWrapper>
                                                            <EcosystemListTitle marginTop='0'>
                                                                <FormattedMessage
                                                                    id='approvedTriggers' />
                                                            </EcosystemListTitle>
                                                        </EcosystemListTitleWrapper>
                                                    </Col>
                                                </Row>
                                                <Accordion
                                                    items={approvedCriterionCs}
                                                    contentProps={{ updateCriterionC, site }}
                                                    headerProps={{ openRemoveCriterionCModal, getCriterionCs, site }}
                                                    contentComponent={AccordionContent}
                                                    headerComponent={AccordionHeader}
                                                    initialActive={null}
                                                />
                                            </>
                                        )}
                                        {rejectedCriterionCs.length > 0 && (
                                            <>
                                                <Row>
                                                    <Col md={8} mdOffset={2}>
                                                        <EcosystemListTitleWrapper>
                                                            <EcosystemListTitle marginTop='48px'>
                                                                <FormattedMessage
                                                                    id='rejectedTriggers' />
                                                            </EcosystemListTitle>
                                                        </EcosystemListTitleWrapper>
                                                    </Col>
                                                </Row>
                                                <Accordion
                                                    items={rejectedCriterionCs}
                                                    contentProps={{ updateCriterionC, site }}
                                                    headerProps={{ openRemoveCriterionCModal, getCriterionCs, site }}
                                                    contentComponent={AccordionContent}
                                                    headerComponent={AccordionHeader}
                                                    initialActive={null}
                                                />
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
            <Modal
                width={'416px'}
                isOpen={isRemoveCriterionCModalOpen}
                toggleModal={setIsRemoveCriterionCModalOpen}
                modalTitleId='removeCriterionC'
                bottomBorder={true}
            >
                <RemoveCriterionCModal
                    item={willBeDeletedCriterionC}
                    closeModal={() => {
                        setIsRemoveCriterionCModalOpen(false)
                    }}
                    confirmRemove={async() => {
                        await requestDeleteCriterionC(willBeDeletedCriterionC.site_ecointegrity_history_id || willBeDeletedCriterionC.site_ecointegrity_id)
                        setIsRemoveCriterionCModalOpen(false)
                    }}
                />
            </Modal>
        </div>
    )
}

export default criterionCList